const types = {
  UPDATE_JOB: '@form/job/UPDATE',
  RESET_JOB: '@form/job/RESET_JOB',
  ADD_JOB: '@form/job/ADD_JOBs',
};

export default types;
